

import request from '../base/request';
import {applicationName} from "../utils";

let host = "/cm-sites-" + applicationName() + '/';

const Apis = {
    configListInitDataSource: host + 'config/list',
    configAdd:host+'config/add',
    configUpdate:host+'config/edit',
    configDelete:host+'config/deleteById',
    configDeletes:host+'config/deleteByIds',
    getConfigByKey:host+'config/getByConfigKey',
};

export const configListInitDataSource = (start, size,param, callBack) => {
    request({url:Apis.configListInitDataSource, body:{start,size,...param}, method:"post", callBack});
};
export const configAdd = (config, callBack) => {
    request({url:Apis.configAdd, contentType:"json", body:config, method:"post", callBack});
};
export const configUpdate = (config, callBack) => {
    request({url:Apis.configUpdate, contentType:"json", body:config, method:"post", callBack});
};
export const configDelete = (id, callBack) => {
    request({url:Apis.configDelete, body:id, method:"post", callBack});
};
export const configDeletes = (ids, callBack) => {
    request({url:Apis.configDeletes,contentType:"json", body:ids, method:"post", callBack});
};
export const getConfigByKey = (key, callBack) => {
    request({url:Apis.getConfigByKey, body:key, method:"post", callBack});
};